import { Grid, GridItem, Heading } from '@which/seatbelt'

import classNames from 'classnames'

import type { RecommendedContentType } from '../../../models'
import { RecommendationCard } from '../layoutElements/RecommendationCard'
import styles from './RecommendationsTwoByTwoLayout.module.scss'

type RecommendedTwoByTwoLayoutProps = {
  content: RecommendedContentType[]
  title: string
  whichId: string
  modelId: string
}

export const RecommendationsTwoByTwoLayout = ({
  content,
  title,
  whichId,
  modelId,
}: RecommendedTwoByTwoLayoutProps) => (
  <Grid data-testid={'r4u-2x2'} className={classNames('w-page-wrapper', styles.sectionSpacing)}>
    <GridItem
      columnStart={{ large: 2 }}
      span={{ large: 10 }}
      className={styles.mobileMaxWidthWrapper}
    >
      <Heading headingType="large" heading={title} headingTag="h2" />

      <div className={styles.recommendedArticlesContainer}>
        {content?.map((content, index) => (
          <RecommendationCard
            content={content}
            whichId={whichId}
            modelId={modelId}
            index={index}
            key={content.id}
            large={false}
          />
        ))}
      </div>
    </GridItem>
  </Grid>
)
